const { default: gtagV4 } = require('./google-analytics-v4')

//mailto click events capture
document.querySelectorAll('a[href^="mailto"]').forEach((mail) => {
  mail.addEventListener('click', () => {
    gtagV4('contact_email')
  })
})

function storeRealPhoneData(phone) {
  //save original attribute
  phone.setAttribute('data-href', phone.getAttribute('href'))
  phone.setAttribute('data-value', phone.innerText)

  //override
  phone.setAttribute('href', 'javascript:void(0)')
  phone.innerText = phone.innerText.substr(0, 5) + '[...mostra]'
}

function showRealPhoneData(phone) {
  if (phone.hasAttribute('data-href')) {
    phone.setAttribute('href', phone.getAttribute('data-href'))
    phone.innerText = phone.getAttribute('data-value')

    phone.removeAttribute('data-href')
    phone.removeAttribute('data-value')

    return true
  }

  return false
}

//convert all phone <strong> without href="tel"
const phoneToCall = `tel://0039${process.env.MIX_PHONE_NUMBER.replace(
  / /g,
  ''
)}`

const phones = document.evaluate(
  `//strong[text()="${process.env.MIX_PHONE_NUMBER}"]`,
  document,
  null,
  XPathResult.ANY_TYPE,
  null
)

const phonesToConvert = []
while ((p = phones.iterateNext())) phonesToConvert.push(p)

phonesToConvert.forEach((p) => {
  p.innerHTML = `<a href="${phoneToCall}">${p.innerText}</a>`
})

//then attach phone events show/call
document.querySelectorAll('a[href^="tel"]').forEach((phone) => {
  //not for the contactleft one
  if (phone.id == 'phonecall') return

  // store real data in attribute
  storeRealPhoneData(phone)

  //first over show
  phone.addEventListener('mouseover', () => {
    const showed = showRealPhoneData(phone)
    if (showed) gtagV4('phone_show')
  })

  //first click show if not already visible (for mobile)
  phone.addEventListener('click', () => {
    const showed = showRealPhoneData(phone)
    gtagV4(`phone_${showed ? 'show' : 'call'}`)
  })
})
